const PageTitle = ({ title }) => <h4 className="page-title">{title}</h4>;
export default PageTitle;
